<template>
  <div style="background: #eee">
    <van-sticky>
      <van-nav-bar
        title="质保金"
        left-text="返回"
        left-arrow
        @click-left="goback"
      />
      <van-grid :column-num="2">
        <van-grid-item :text="`质保金: ${warrantyAmount}`" style="    font-size: 16px;" > </van-grid-item>
        <van-grid-item :text="`已缴纳金额: ${paymentAmountTotal}`" />
      </van-grid>
      <van-field
        v-model="remarks"
        rows="1"
        autosize
        readonly
        label="备注"
        type="textarea"
      />
    </van-sticky>
    
    <van-tabs v-model="active">
      <van-tab :title="`支付记录（${paymentAmount}）`">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell-group
            v-for="(item, index) in pageList"
            :key="index"
            style="margin: 1.2rem; text-align: left"
            inset
          >
            <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
              {{ item.settlementBatchName }}
            </div>
            <div
              style="
                width: 0;
                height: 0;
                border: 4rem solid transparent;
                border-top: none;
                border-right-color: green;
                float: right;
                margin-top: -3rem;
                margin-right: 0.8rem;
                position: relative;
                margin-bottom: 0.4rem;
              "
            >
              <span
                style="
                  position: absolute;
                  width: 3rem;
                  height: 4rem;
                  line-height: 2rem;
                  margin-left: 1.4rem;
                  color: #fff;
                  font-size: 0.8rem;
                "
                >质保金</span
              >
            </div>
            <van-field
              label="支付费用"
              :value="item.paymentAmount"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="支付备注"
              :value="item.remarks"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="付款时间"
              :value="item.paymentTime"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="操作时间"
              :value="item.updateTime"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="操作人"
              :value="item.updatedByStr"
              input-align="right"
              readonly
              label-width="5rem"
            />
          </van-cell-group>
        </van-list>
      </van-tab>
      <van-tab :title="`账单抵扣（${settlementIncentiveTotal}）`">
        <van-list
          :finished="true"
          finished-text="没有更多了"
        >
        <van-cell-group
          v-for="(item, index) in settlementIncentiveRecords"
          :key="index"
          style="margin: 1.2rem; text-align: left"
          inset
        >
        <div style="font-size: 1.6rem; padding-top: 2rem; text-align: center">
              {{ item.settlementBatchName }}
            </div>
            <div
              style="
                width: 0;
                height: 0;
                border: 4rem solid transparent;
                border-top: none;
                border-right-color: green;
                float: right;
                margin-top: -3rem;
                margin-right: 0.8rem;
                position: relative;
                margin-bottom: 0.4rem;
              "
            >
              <span
                style="
                  position: absolute;
                  width: 3rem;
                  height: 4rem;
                  line-height: 2rem;
                  margin-left: 1.4rem;
                  color: #fff;
                  font-size: 0.8rem;
                "
                >质保金</span
              >
            </div>
          <van-field label="金额" :value="item.amount" input-align="right" readonly label-width="5rem" />
          <van-field label="备注" :value="item.remarks" input-align="right" readonly label-width="5rem" />
          <van-field label="结算时间" :value="item.paymentTime" input-align="right" readonly label-width="5rem" />
          <!-- <van-field
              label="结算单归属师傅"
              :value="item.settlementResponsibleUserIdStr || '-'"
              input-align="right"
              readonly
              label-width="5rem"
            /> -->
          <van-field
              label="质保操作时间"
              :value="item.updateTime"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="质保操作人"
              :value="item.updatedByStr"
              input-align="right"
              readonly
              label-width="5rem"
            />
        </van-cell-group>
        </van-list>
      </van-tab>
      <van-tab :title="`手动缴纳（${manualPaymentAmount}）`">
        <van-list
          :finished="true"
          finished-text="没有更多了"
        >
        <van-cell-group
          v-for="(item, index) in manualPaymentRecords"
          :key="index"
          style="margin: 1.2rem; text-align: left"
          inset
        >
          <van-field label="金额" :value="item.amount" input-align="right" readonly label-width="5rem" />
          <van-field label="备注" :value="item.remarks" input-align="right" readonly label-width="5rem" />
          <van-field label="支付时间" :value="item.paymentTime" input-align="right" readonly label-width="5rem" />
          <van-field
              label="附件"
              :value="item.attachmentIds ? item.attachmentIds.split(',').length : '无'"
              input-align="right"
              readonly
              label-width="5rem"
              @click="seeFile(item)"
            />
          <van-field
              label="操作时间"
              :value="item.updateTime"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="操作人"
              :value="item.updatedByStr"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-row style="padding: 1rem">
            <van-col span="5.5">
              <van-button
                v-if="item.attachmentIds"
                type="default"
                size="small"
                @click="seeFile(item)"
                >查看支付凭证</van-button
              >
            </van-col>
        </van-row>
        </van-cell-group>
        </van-list>
      </van-tab>
      <van-tab :title="`手动扣减（-${manualDeductionAmount}）`">
        <van-list
          :finished="true"
          finished-text="没有更多了"
        >
        <van-cell-group
          v-for="(item, index) in manualDeductionRecords"
          :key="index"
          style="margin: 1.2rem; text-align: left"
          inset
        >
          <van-field label="金额" :value="item.amount" input-align="right" readonly label-width="5rem" />
          <van-field label="备注" :value="item.remarks" input-align="right" readonly label-width="5rem" />
          <van-field label="支付时间" :value="item.paymentTime" input-align="right" readonly label-width="5rem" />
          <van-field
              label="附件"
              :value="item.attachmentIds ? item.attachmentIds.split(',').length : '无'"
              input-align="right"
              readonly
              label-width="5rem"
              @click="seeFile(item)"
            />
          <van-field
              label="操作时间"
              :value="item.updateTime"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-field
              label="操作人"
              :value="item.updatedByStr"
              input-align="right"
              readonly
              label-width="5rem"
            />
            <van-row style="padding: 1rem">
            <van-col span="5.5">
              <van-button
                v-if="item.attachmentIds"
                type="default"
                size="small"
                @click="seeFile(item)"
                >查看支付凭证</van-button
              >
            </van-col>
        </van-row>
        </van-cell-group>
        </van-list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Big from "big.js";
export default {
  name: "",
  data() {
    return {
        loading:false,
        finished:false,
        pageList:[],
        remarks:'',
        warrantyAmount: 0,
        paymentAmount: 0,
        settlementIncentiveRecords:[],
        manualPaymentRecord:[],
        active: 0
    };
  },
  computed: {
    paymentAmountTotal() {
      const amount = this.settlementIncentiveRecords.reduce((pre, cur) => {
        return pre.plus(new Big(cur.amount || 0));
      }, new Big(0));
      const amount2 = this.manualPaymentRecord.reduce((pre, cur) => {
        // 根据type字段判断：1-缴纳记录(+)，2-扣减记录(-)
        const amountValue = new Big(cur.amount || 0);
        if (cur.type === 1) {
          // 缴纳记录，金额为正
          return pre.plus(amountValue);
        } else if (cur.type === 2) {
          // 扣减记录，金额为负
          return pre.minus(amountValue);
        }
        // 默认按原逻辑处理
        return pre.plus(amountValue);
      }, new Big(0));

      return new Big(this.paymentAmount || 0)
        .plus(amount)
        .plus(amount2)
        .toString();
    },
    manualPaymentTotal() {
      return this.manualPaymentRecord.reduce((pre, cur) => {
        // 根据type字段判断：1-缴纳记录(+)，2-扣减记录(-)
        const amountValue = new Big(cur.amount || 0);
        if (cur.type === 1) {
          // 缴纳记录，金额为正
          return pre.plus(amountValue);
        } else if (cur.type === 2) {
          // 扣减记录，金额为负
          return pre.minus(amountValue);
        }
        // 默认按原逻辑处理
        return pre.plus(amountValue);
      }, new Big(0)).toString();
    },
    settlementIncentiveTotal() {
      return this.settlementIncentiveRecords.reduce((pre, cur) => pre.plus(new Big(cur.amount || 0)), new Big(0)).toString();
    },
    // 缴纳记录（type === 1）
    manualPaymentRecords() {
      return this.manualPaymentRecord.filter(item => item.type === 1);
    },
    // 扣减记录（type === 2）
    manualDeductionRecords() {
      return this.manualPaymentRecord.filter(item => item.type === 2);
    },
    // 缴纳记录总金额
    manualPaymentAmount() {
      return this.manualPaymentRecords.reduce((pre, cur) => {
        return pre.plus(new Big(cur.amount || 0));
      }, new Big(0)).toString();
    },
    // 扣减记录总金额
    manualDeductionAmount() {
      return this.manualDeductionRecords.reduce((pre, cur) => {
        return pre.plus(new Big(cur.amount || 0));
      }, new Big(0)).toString();
    }
  },
  methods: {
    seeFile(item){
        this.$router.push({
          path:'/settlement/fileList',
          query:{
            attachmentIds:item.attachmentIds,
          }
        })
     },
    goback() {
      this.$router.push("/");
    },
    onLoad(){
        // 加载数据
      this.getPageData()
    },
    getPageData(){
      this.axios({
        url:'/v1/web/user-info/h5/getWarrantyAmount',
        method:'get',
      }).then(res=>{
        this.pageList = res.data.data.paymentRecord
        this.remarks = res.data.data.warrantyRemark
        this.warrantyAmount = res.data.data.warrantyAmount || 0
        this.paymentAmount = res.data.data.paymentAmount || 0
        this.loading = false
        this.finished = true
      })


      this.axios({
        url: "/v1/web/manual-warranty-fund/h5/list",
        method: "post",
        data: {
         queryInfoParams:{
         },
          page: 1,
          size: 2000,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.manualPaymentRecord = res.data.data.list; // 缴纳记录
        } 
      });

            // 获取质保金账单抵扣记录
       this.axios({
        url: "/v1/web/user-info/h5/listSettlementIncentive",
        method: "get",
        params: {
          userId: this.userId,
        },
      }).then((res) => {
        if (res.data.code == 200) {
          this.settlementIncentiveRecords = res.data.data; // 缴纳记录
        }
      });

      
    }
    
  },
};
</script>

<style></style>
